import React from 'react'
import '../styles/Themes.css'
import d1 from '../assets/df1.png';
import d2 from '../assets/df2.png';
import d3 from '../assets/df3.png';
import d4 from '../assets/df4.png';
import d5 from '../assets/df5.png';

import d6 from '../assets/df6.png';
import d7 from '../assets/df7.png';
import d8 from '../assets/df8.png';
import d9 from '../assets/df9.png';
import d10 from '../assets/df10.png';
export default function Themes() {
  return (
    <div className='themes_container'id="themes_container">
        
        <section>
            <h1>Our NFTs in different themes...</h1>
            <p>We have selected 10 themes each depecting a type of human emotion, and we have designed each and every theme according to the colour psycology of that perticular emotion</p>

            <div id="img_grid">
            <div class="img_container">
                    <img src={d1}/>
                </div>
                <div class="img_container">
                    <img src={d2}/>
                </div>
                <div class="img_container">
                    <img src={d3}/>
                </div>
                <div class="img_container">
                    <img src={d4}/>
                </div>
                <div class="img_container">
                    <img src={d5}/>
                </div>
                <div class="img_container">
                    <img src={d6}/>
                </div>
                <div class="img_container">
                    <img src={d7}/>
                </div>
                <div class="img_container">
                    <img src={d8}/>
                </div>
                <div class="img_container">
                    <img src={d9}/>
                </div>
                <div class="img_container">
                    <img src={d10}/>
                </div>
            </div>
        </section>

    </div>
  )
}
